export default __webpack_public_path__ + "assets/1300666f5df34ab9445730425a0d27ce.png";